
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AutomationEventType, OwnershipLevel } from '@fitness-force/enum';
import { environment } from '@fitness-force/environments';
import { Observable, catchError, map, throwError } from 'rxjs';
import { AppErrors, BadRequestError, NotFoundError } from '@fitness-force/models';;
import type { AutomationByIdResponse, AutomationMaster } from '@fitness-force/models';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';

@Injectable({
  providedIn: 'root'
})
export class AutomationmasterService {
  private http = inject(HttpClient);
  private router = inject(Router);

  BASE_URL: string = environment.BASE_URL;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  GetAutomationMaster(tenantId:number,eventType: string): Observable<AutomationMaster[]> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.AUTOMATION.GET_AUTOMATION_MASTER
      .replace('{tenant_id}', tenantId.toString())
      .replace('{event_type}', eventType);
    return this.http.get(url, {
      headers: this.httpOptions.headers,
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  GetAutomationMasters(): Observable<AutomationMaster[]> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.COMPANIES.GET_AUTOMATION_TYPES;
    return this.http.get(url, {
      headers: this.httpOptions.headers,
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  GetAutomationByUuid(uuid:string): Observable<AutomationByIdResponse> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.COMPANY.GET_AUTOMATION_BY_UUID
      .replace('{uuid}', uuid);
    return this.http.get(url, {
      headers: this.httpOptions.headers,
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  GetCompanyAutomations(): Observable<any[]> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.COMPANY.GET_COMPANY_AUTOMATIONS;
    return this.http.get(url, {
      headers: this.httpOptions.headers,
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  CreateCompanyAutomation(payload: any): Observable<any> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.COMPANY.CREATE_AUTOMATION;
    return this.http.post(url, payload, {
      headers: this.httpOptions.headers,
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  UpdateCompanyAutomation(guid: string, payload: any): Observable<any> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.COMPANY.UPDATE_AUTOMATION
      .replace('{uuid}', guid);
    return this.http.put(url, payload, {
      headers: this.httpOptions.headers,
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  MarkAutomationAsActive(guid: string): Observable<any> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.COMPANY.MARK_AUTOMATION_ACTIVE
      .replace('{uuid}', guid);
    return this.http.put(url, {}, {
      headers: this.httpOptions.headers,
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

  MarkAutomationAsInactive(guid: string): Observable<any> {
    const url = environment.BASE_URL + CONST_URL_SEGEMENTS.COMPANY.MARK_AUTOMATION_INACTIVE
      .replace('{uuid}', guid);
    return this.http.put(url, {}, {
      headers: this.httpOptions.headers,
    }).pipe(
      map((res: any) => {
        return res
      }),
      catchError((error: Response) => {
        if (error.status === 404) {
          return throwError(() => new NotFoundError(error));
        } else if (error.status === 400) {
          return throwError(() => new BadRequestError(error))
        }
        return throwError(() => new AppErrors(error));
      })
    );
  }

}
